import {
  Button,
  Flex,
  Input,
  InputGroup,
  Grid,
  GridItem,
  SimpleGrid,
  Divider,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

import React, { useEffect, useState } from "react";
import CustomSelect from "../CustomSelect";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import pt from "date-fns/locale/pt-BR";
import {
  Permission,
  motivoFunc,
  visitasFunc,
  servicos,
  doencaFunc,
  situacaoJuridica,
} from "../../../helpers/Funcionalidades";

export default function Filters(props) {
  const {
    filtrar,
    placeholderFilter,
    limparFiltros,
    status,
    setStatus,
    entidade,
    setTipoSJ,
    tipoSJ,
    tipoMS,
    setTipoMS,
    riscoVida,
    setRiscoVida,
    extincaoPoderFamiliar,
    setExtincaoPoderFamiliar,
    setDescricaoPai,
    setModalidade,
    modalidade,
    descricaoPai,
    regime,
    setRegime,
    roleKeycloack,
  } = props;
  const [descricao, setDescricao] = useState("");
  const history = useHistory();

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    let activeFilters = {};
    if (sessionStorage.getItem(entidade + "-filter")) {
      activeFilters = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
    }
    setDescricao(
      activeFilters.descricao ||
        activeFilters.modalidade ||
        activeFilters.crianca
    );
  }, [entidade]);

  function filtrarDescricao() {
    sessionStorage.setItem(entidade + "-filtering", true);
    if (entidade === "tipo-servico-acolhimento") {
      if (descricao === modalidade) {
        filtrar();
      } else {
        setModalidade(descricao);
      }
    } else {
      if (descricao === descricaoPai) {
        filtrar();
      } else {
        setDescricaoPai(descricao);
      }
    }
  }

  function limparFiltrosSon() {
    setDescricao("");
    setDescricaoPai();
    setModalidade();
    limparFiltros();
  }

  return (
    <Flex flex={1} flexDir="column" alignItems="center">
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
          lg: "repeat(3, 1fr)",
          xl:
            entidade === "motivo-situacao"
              ? "repeat(5, 1fr)"
              : "repeat(4, 1fr)",
        }}
        gap="17px"
        w="100%"
      >
        <GridItem
          colSpan={{ base: 1, sm: entidade === "motivo-situacao" ? 1 : 2 }}
          h="42px"
        >
          <InputGroup>
            <Input
              name="descricao"
              autoFocus
              value={descricao || ""}
              onChange={(e) => setDescricao(e.target.value)}
              id="search-descricao"
              w="100%"
              backgroundColor="white"
              autoComplete="off"
              placeholder={placeholderFilter}
              h="42px"
              onKeyDown={(event) => event.key === "Enter" && filtrarDescricao()}
            />
          </InputGroup>
        </GridItem>

        <GridItem colSpan={1} h="42px">
          <CustomSelect
            value={status}
            options={[
              { label: "Ativos", value: "ativos" },
              { label: "Inativos", value: "inativos" },
            ]}
            placeholder="Filtrar por Status"
            onChange={(value) => {
              setStatus(value);
            }}
          />
        </GridItem>

        {entidade === "tipo-servico-acolhimento" && (
          <GridItem colSpan={1} h="42px">
            <CustomSelect
              value={regime}
              options={[
                { label: "Serviço de Acolhimento Institucional", value: "SAI" },
                { label: "Serviço de Acolhimento Familiar", value: "SAF" },
              ]}
              placeholder="Filtrar por Regime"
              onChange={(value) => {
                setRegime(value);
              }}
            />
          </GridItem>
        )}

        {entidade === "situacao-juridica" && (
          <GridItem colSpan={1} h="42px">
            <CustomSelect
              value={tipoSJ}
              options={[
                { label: "Processo", value: "P" },
                { label: "Procedimento", value: "D" },
              ]}
              placeholder="Filtrar pelo Tipo"
              onChange={(value) => {
                setTipoSJ(value);
              }}
            />
          </GridItem>
        )}

        {entidade === "motivo-situacao" && (
          <GridItem colSpan={1} h="42px">
            <CustomSelect
              value={tipoMS}
              options={[
                { label: "Acolhido", value: 1 },
                { label: "Desligado", value: 2 },
              ]}
              placeholder="Filtrar pelo Tipo"
              onChange={(value) => {
                setTipoMS(value);
              }}
            />
          </GridItem>
        )}

        {entidade === "motivo-situacao" && (
          <GridItem colSpan={1} h="42px">
            <CustomSelect
              normal={true}
              value={riscoVida}
              options={[
                { label: "Sim", value: "S" },
                { label: "Não", value: "N" },
              ]}
              placeholder="Filtrar por Risco de Vida"
              onChange={(value) => {
                setRiscoVida(value);
              }}
            />
          </GridItem>
        )}

        {entidade === "motivo-situacao" && (
          <GridItem colSpan={1} h="42px">
            <CustomSelect
              normal={true}
              value={extincaoPoderFamiliar}
              options={[
                { label: "Sim", value: "S" },
                { label: "Não", value: "N" },
              ]}
              placeholder="Filtrar por Houve Extinção do Poder Familiar"
              onChange={(value) => {
                setExtincaoPoderFamiliar(value);
              }}
            />
          </GridItem>
        )}
      </Grid>

      <SimpleGrid
        mt="20px"
        columns={{ base: 3, lg: 3 }}
        spacing="15px"
        w={{ base: "100%", lg: "47%" }}
      >
        <Permission
          roleKeycloack={roleKeycloack}
          func={
            entidade === "visitas"
              ? visitasFunc.visitaConsultar
              : entidade === "motivo-situacao"
              ? motivoFunc.motivoConsultar
              : entidade === "tipo-servico-acolhimento"
              ? servicos.tipoServicoConsultar
              : entidade === "situacao-juridica"
              ? situacaoJuridica.situacaoJuridicaConsultar
              : entidade === "motivo-situacao"
              ? motivoFunc.motivoSituacaoConsultar
              : entidade === "doenca"
              ? doencaFunc.doencaConsultar
              : ""
          }
        >
          <Button
            color="#FFF"
            backgroundColor="#169499"
            fontWeight={700}
            fontSize="15px"
            lineHeight="21.6px"
            _hover={{ bg: "#169499" }}
            onClick={filtrarDescricao}
          >
            Pesquisar
          </Button>
        </Permission>

        <Button
          color="#FFF"
          backgroundColor="#169499"
          fontWeight={700}
          fontSize="15px"
          lineHeight="21.6px"
          _hover={{ bg: "#169499" }}
          onClick={limparFiltrosSon}
        >
          Limpar
        </Button>
        <Permission
          roleKeycloack={roleKeycloack}
          func={
            entidade === "visitas"
              ? visitasFunc.visitaCadastrar
              : entidade === "motivo-situacao"
              ? motivoFunc.motivoCadastrar
              : entidade === "tipo-servico-acolhimento"
              ? servicos.tipoServicoConsultar
              : entidade === "situacao-juridica"
              ? situacaoJuridica.situacaoJuridicaCadastrar
              : entidade === "motivo-situacao"
              ? motivoFunc.motivoSituacaoCadastrar
              : entidade === "doenca"
              ? doencaFunc.doencaCadastrar
              : ""
          }
        >
          <Button
            color="#FFF"
            backgroundColor="#169499"
            fontWeight={700}
            fontSize="15px"
            lineHeight="21.6px"
            _hover={{ bg: "#169499" }}
            onClick={() => {
              history.push("/" + entidade + "/cadastrar");
            }}
          >
            Cadastrar
          </Button>
        </Permission>
      </SimpleGrid>

      <Divider
        borderColor="#DDEBEA"
        orientation="horizontal"
        mt="18px"
        h="2px"
      />
    </Flex>
  );
}
